import React from 'react';
import Box from '@mui/material/Box';
import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { useBuildType } from 'src/hooks';
import { hexToRGB } from 'src/components/Marketplace/helpers';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  property: IFilterAllData;
  withCloseButton?: boolean;
  onCloseClick?: () => void;
}
export const ApartmentStatus2dView: React.FC<Props> = ({ property, withCloseButton = true, onCloseClick }) => {
  const { isCrossTable } = useBuildType();
  const color = isCrossTable
    ? (property?.[ListOfKeysFilterAllData.placementStatusCrossTableColor]?.toString()
      || property?.[ListOfKeysFilterAllData.placementStatusColor]?.toString() || '')
    : (property?.[ListOfKeysFilterAllData.placementStatusColor]?.toString() || '');
  const backgroundColorWithOpacity = hexToRGB(color, '.1');
  const borderBottom = `1px solid ${color}`;
  // Figma "Interface update FS": 16px close glyph in the muted ink color.
  const closeBtnFillColor = '#5E5E60';
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p="8px 16px"
      fontSize="12px"
      width="100%"
      height="36px"
      borderBottom={borderBottom}
      style={{
        backgroundColor: backgroundColorWithOpacity,
      }}
    >
      <Box
        fontWeight="400"
        lineHeight="16px"
        display="flex"
        gap="8px"
        alignItems="center"
      >
        <Box
          display="flex"
          width="20px"
          height="20px"
          borderRadius="4px"
          style={{
            backgroundColor: color,
          }}
        />
        <Box color="#000" fontSize="12px" fontWeight="500" lineHeight="16px">
          {property?.[ListOfKeysFilterAllData.placementStatusCrossTableName]}
        </Box>
      </Box>
      {withCloseButton && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="16px"
          height="16px"
          style={{
            cursor: 'pointer',
          }}
          onClick={onCloseClick}
        >
          <CloseIcon style={{
            fontSize: 16,
            color: closeBtnFillColor,
          }}
          />
        </Box>
      ) }
    </Box>
  );
};
